import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import { Tooltip } from 'bootstrap';
import { SetBSFormValidation } from '../utilities/Forms';


const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
tooltipTriggerList.forEach(function (tooltipTriggerEl) {
  return new Tooltip(tooltipTriggerEl);
});

// Fetch all the forms we want to apply custom Bootstrap validation styles to
const forms = document.querySelectorAll('.needs-validation');
if (forms) {
  // Loop over them and prevent submission
  SetBSFormValidation(Array.prototype.slice.call(forms));
}
